// extracted by mini-css-extract-plugin
export default {"head_container":"Checkout_head_container__qmzm0","title":"Checkout_title__n8k9b","link":"Checkout_link__UYz3z"};